/**
 * @category  sc
 * @package   Product_Test
 * @author    Ali Eltahan <info@alieltahan.com>
 */

import React, { Component } from 'react';
import MainComponent from './Main.component';

class MainContainer extends Component {
    render () {
        return (
            <MainComponent />
        );
    }
}

export default MainContainer;